import styled, { css } from 'styled-components';

export const BodyContentWrapper = styled.div`
  ${() => css`
    display: grid;
    grid-template-columns: 400px 1fr; /* Primeira coluna com no máximo 400px */
    gap: 2.4rem;
    margin-top: 1.6rem;

    @media (max-width: 1024px) {
      grid-template-columns: 1fr; /* Quando a tela for menor que 1024px, o layout vira uma coluna */
    }
  `}
`;

export const WrapperTitle = styled.div`
  ${() => css`
    margin-bottom: 2.4rem;
  `}
`;
export const BoxContent = styled.div`
  ${() => css`
    margin-bottom: 2.4rem;
  `}
`;
export const Circle = styled.div<{ percentage: string }>`
  ${({ percentage }) => css`
    width: 33.33px;
    height: 33.33px;
    border-radius: 50%;
    background: conic-gradient(
      #dd442c 0% ${percentage}%,
      #f5f5f5 ${percentage}% 100% /* Cor cinza para o restante da borda */
    );
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 4px;
      left: 4px;
      right: 4px;
      bottom: 4px;
      border-radius: 50%;
      background-color: white; /* Cor do fundo do círculo */
    }
    ${percentage === '100' &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: white; /* Cor de fundo quando a porcentagem é 100% */

      &::after {
        background-color: white; /* Remover fundo branco */
      }

      svg {
        z-index: 1;
      }
    `}
  `}
`;
export const TitleAside = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  .title {
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.4px;
    font-weight: 600;
  }
`;
export const GridInfos = styled.div`
  display: grid;
  margin-top: 16px;
  grid-template-columns: repeat(3, 1fr); /* 2 colunas */
  gap: 8px; /* Espaçamento entre os itens */

  @media (max-width: 800px) {
    grid-template-columns: 1fr; /* 1 coluna quando a largura for menor que 800px */
  }
`;
export const WrapperMain = styled.main`
  ${() => css`
    width: 100%;

    > div {
      margin-bottom: 2rem;
    }
  `}
`;
export const Grid = styled.div`
  display: grid;
  margin-bottom: 16px;
  grid-template-columns: repeat(2, 1fr); /* 2 colunas */
  gap: 8px; /* Espaçamento entre os itens */

  @media (max-width: 800px) {
    grid-template-columns: 1fr; /* 1 coluna quando a largura for menor que 800px */
  }
`;
export const TextAside = styled.div<{
  fontWeight?: string;
  color?: string;
  fontSize?: string;
  cursor?: boolean;
}>`
  ${({ fontWeight, color, fontSize, cursor }) => css`
    font-size: ${fontSize ? `${fontSize}px` : '16px'};
    line-height: 24px;
    letter-spacing: -0.4px;
    color: ${color ? color : 'black'};
    font-weight: ${fontWeight ? fontWeight : '500'};
    cursor: ${cursor ? 'pointer' : 'default'};
  `}
`;
export const TextCustom = styled.span<{
  fontWeight?: string;
  color?: string;
  fontSize?: string;
  cursor?: boolean;
}>`
  ${({ fontWeight, color, fontSize, cursor }) => css`
    font-size: ${fontSize ? `${fontSize}px` : '16px'};
    line-height: 24px;
    letter-spacing: -0.4px;
    color: ${color ? color : 'black'};
    font-weight: ${fontWeight ? fontWeight : '500'};
    cursor: ${cursor ? 'pointer' : 'default'};
  `}
`;
export const WrapperAside = styled.div`
  ${({ theme }) => css`
    > aside:first-child {
      margin-bottom: 1.6rem;
    }
    p {
      display: flex;
      justify-content: space-between;
      font-size: ${theme.font.sizes.medium};
      color: ${theme.colors.neutral.neutral130};
      line-height: 2.4rem;
      letter-spacing: -0.4px;
      font-weight: 500;
    }
  `}
`;

export const contentAside = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.neutral.neutral0};
    border-radius: ${theme.border.radius};
    padding: 24px;
  `}
`;
